import React, { useEffect,useState } from "react";
import { Modal } from "antd";
import { Link, useNavigate } from "react-router-dom";

import "./nujobsSearchResults.scss";
import JobListingsSearch from "../../../landing/nujobs/jobListingSearch";
import JobListingSearchResults from "../../../landing/nujobs/jobListingSearchResults";
import useNuJobsStore from "../../../store/nujobs.store";
import useNuJobDetailsStore from "../../../store/nujobsdetails.store";


function NuJobsSearchResults() {
  const { nujobsApplyNow, myJds, nuJobsGetMyJDs } = useNuJobDetailsStore();
  const { resetApplyNowPopRouting } = useNuJobsStore();
  useEffect(() => {
    resetApplyNowPopRouting();
    nuJobsGetMyJDs();
  }, []);

  const encodeJson = (selectedJD) =>{
      let encodedJsonValues ={};
      //now override keyword and location
      encodedJsonValues.qhoid= selectedJD.QhOID;
      encodedJsonValues.qhcompanyjid=selectedJD.QhCompanyJID;
      encodedJsonValues.companyname=selectedJD.CompanyName;  

      //console.log(".....",encodedJsonValues)                            
      return encodedJsonValues
  }

  const applyNowCallBackLoggedIn = async (selectedJD) => {
    try {
      const jasonValues = encodeJson(selectedJD);
      await nujobsApplyNow(0, jasonValues);
    } catch (err) {
      alert("Application failed. Please try again.");
      return err;
    }
  };

  const alreadyApplied = (selectedJD) =>{
       const applied = myJds?.some((j) =>
      (j) =>
        j.jd_details.qhcompanyjid === selectedJD?.QhCompanyJID &&
        j.jd_details.qhoid === selectedJD?.QhOID,
    );
    return applied;
  };

    return (
        <div className="nujobsSearchResults-wrapper">
            <JobListingSearchResults 
                loggedIn = {true} 
                applyNowCallBackLoggedIn = {applyNowCallBackLoggedIn} 
                alreadyApplied = {alreadyApplied}/>
        </div>
    );
}

export default NuJobsSearchResults;
